// extracted by mini-css-extract-plugin
export var closed = "_9l-1";
export var resizer = "_9l-0";